import { useState } from "react";
import type { FaqItem } from "@/mocks/guaData";

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100/60">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex(isOpen ? null : index)}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 md:px-5"
              >
                <span className="text-sm font-bold text-foreground-950 md:text-base">
                  {item.question}
                </span>
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                    isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  <i className={isOpen ? "ri-subtract-line text-base" : "ri-add-line text-base"} aria-hidden="true" />
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="px-4 pb-5 md:px-5">
                <p className="max-w-3xl text-sm leading-relaxed text-foreground-600">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}